/**
 * Organizations API Service
 * Handles organization listing operations.
 *
 * Base URL: /api (apiFetch adds /api prefix)
 */
import { useCallback, useMemo } from "react";
import { useApi } from "@/hooks/use-api";
import type { OrganizationListResponseDto } from "@/types/api/organizations";

const ORGANIZATIONS_BASE = "/organizations";

/**
 * Hook providing organization API operations with authentication
 */
export function useOrganizationsApi() {
    const api = useApi();

    /**
     * List organizations for the authenticated user's client
     * GET /organizations?limit={limit}&offset={offset}
     */
    const getOrganizations = useCallback(
        async (limit = 100, offset = 0): Promise<OrganizationListResponseDto> => {
            const params = new URLSearchParams();
            params.set("limit", String(limit));
            params.set("offset", String(offset));
            return api.get<OrganizationListResponseDto>(`${ORGANIZATIONS_BASE}?${params.toString()}`);
        },
        [api],
    );

    return useMemo(
        () => ({
            getOrganizations,
        }),
        [getOrganizations],
    );
}
